import { merge } from 'lodash';
import ReactApexChart from 'react-apexcharts';
// material
import { Typography } from '@mui/material';
import { BaseOptionChart } from '../../dash_charts/BaseOptionChart';

const CHART_DATA = [

    {name: 'Instruções',
        data: [
            {
            x: '01/01/2022',
            y: 12,
            goals: [
                {
                name: 'Esperadas',
                value: 14,
                strokeWidth: 20,
                strokeHeight: 5,
                strokeLineCap: 'round',
                strokeColor: '#91C2C1'
                }
            ]
            },
            {
            x: '02/01/2022',
            y: 44,
            goals: [
                {
                name: 'Esperadas',
                value: 80,
                strokeWidth: 20,
                strokeHeight: 5,
                strokeLineCap: 'round',
                strokeColor: '#91C2C1'
                }
            ]
            },
            {
            x: '03/01/2022',
            y: 54,
            goals: [
                {
                name: 'Esperadas',
                value: 70,
                strokeWidth: 20,
                strokeHeight: 5,
                strokeLineCap: 'round',
                strokeColor: '#91C2C1'
                }
            ]
            },
            {
            x: '04/01/2022',
            y: 66,
            goals: [
                {
                name: 'Esperadas',
                value: 66,
                strokeWidth: 20,
                strokeHeight: 5,
                strokeLineCap: 'round',
                strokeColor: '#91C2C1'
                }
            ]
            },
            {
            x: '05/01/2022',
            y: 81,
            goals: [
                {
                name: 'Esperadas',
                value: 130,
                strokeWidth: 20,
                strokeHeight: 5,
                strokeLineCap: 'round',
                strokeColor: '#91C2C1'
                }
            ]
            },
            {
            x: '06/01/2022',
            y: 67,
            goals: [
                {
                name: 'Esperadas',
                value: 90,
                strokeWidth: 20,
                strokeHeight: 5,
                strokeLineCap: 'round',
                strokeColor: '#91C2C1'
                }
                ]
            }
        ]
    }
];

export default function TaxaRealizacaoExercicios() {

  const chartOptions = merge(BaseOptionChart(), {
    chart: {
        height: 350,
        type: 'bar'
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: '80%',
          borderRadius: 4,
        }
      },
      xaxis: { 
        type: 'datetime',
        /*
        labels: {
            format: 'dd/MM'
          }*/
      },
      dataLabels: {
          enabled:true,
          style: {
            fontSize: '12px',
            //fontFamily: 'Helvetica, Arial, sans-serif',
            fontWeight: 'bold',
        },
        formatter: function(val, opt) {
          const goals =
            opt.w.config.series[opt.seriesIndex].data[opt.dataPointIndex]
              .goals
      
          if (goals && goals.length) {
            return `${Math.round((val/goals[0].value)*100)}%`
            //return `${val/goals[0].value} %`
          }
          return val
        }
      },
      legend: {
        show: true,
        showForSingleSeries: true,
        customLegendItems: ['Instruções Realizadas','Total de Instruções'],
        markers: {
          fillColors: ['#358A8B','#91C2C1'] //['#91C2C1','#358A8B'] //['#358A8B','#FF4842']
        }
      }
  });

  return (
    <Typography variant="h6">Taxa de Instruções Realizadas
    <ReactApexChart type="bar" series={CHART_DATA} options={chartOptions} height={250} />
    </Typography>
  );
}
